(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const allProductsCollection = document.querySelector('.collection-page[data-default-sort="best-selling"]');

  if (allProductsCollection) {
    const collectionUrl = new URL(window.location.href);

    if (!collectionUrl.searchParams.has('sort_by')) {
      collectionUrl.searchParams.set('sort_by', 'best-selling');
      window.location.replace(collectionUrl.toString());
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const page = document.querySelector('[data-product-page]');
    if (!page) return;
    const form = page.querySelector('[data-product-form]');
    const stickyButton = page.querySelector('[data-sticky-atc]');
    const selector = form?.querySelector('select[name="id"]');
    const updateVariant = () => {
      const selected = selector?.selectedOptions[0];
      if (!selected) return;
      page.querySelectorAll('[data-variant-price]').forEach(el => el.textContent = selected.dataset.price);
      page.querySelector('[data-variant-status]').textContent = selected.dataset.status;
      page.querySelectorAll('.product-atc, [data-sticky-atc]').forEach(button => {
        button.disabled = selected.dataset.available !== 'true';
        button.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
      });
      const url = new URL(window.location.href);
      url.searchParams.set('variant', selected.value);
      window.history.replaceState({}, '', url);
    };
    selector?.addEventListener('change', updateVariant);
    if (selector) updateVariant();
    if (form && stickyButton) stickyButton.addEventListener('click', () => form.requestSubmit());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('[data-product-recommendations]');
    if (!container || !container.dataset.url) return;
    fetch(container.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const replacement = html.querySelector('[data-product-recommendations]');
        if (replacement && replacement.innerHTML.trim().length) container.innerHTML = replacement.innerHTML;
      })
      .catch(() => {});
  });

  } catch(e) { console.error(e); }
})();
})();
